<template>
    <div class="titleview_bg">
        <!-- <div class="line_left"></div> -->
        <div class="titleview_lab">{{title}}</div>
        <!-- <div class="line_right"></div> -->
    </div>
</template>
        
<script>
export default {
    name:'',
    props:{
        title:String
    },
    data(){
        return{
        
        }
    },
    created(){
       
    },
    methods:{
      
    }
}
</script>
     
<style scoped>

.titleview_bg{
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 50px;
}

.line_left{
    background: url(../assets/line_left.png) no-repeat;
    background-size: contain;
    width: 200px;
    height: 10px;
    margin: 0 10px;
}
.line_right{
    background: url(../assets/line_right.png) no-repeat;
    background-size: contain;
    width: 200px;
    height: 10px;
    margin: 0 10px;
}

.titleview_lab{
    /* background: url(../assets/shape_title1.png)no-repeat;
    background-size: contain; */
    margin: 0 auto;
    width: 1192px;
    height: 57px;
    color: #C80018;
    font-size: 22px;
    font-weight: bold;
    line-height: 57px;
    text-align: center;
    cursor: pointer;
}

</style>